export default "__VITE_ASSET__6oRkST$M__"